import React from 'react';
import classes from './ContentCategoryImages.module.css';
import basics from 'assets/images/postCategories/basics.svg';
import bigs from 'assets/images/postCategories/bigs.svg';
import birthdays from 'assets/images/postCategories/birthday.svg';
import celebrations from 'assets/images/postCategories/celebrations.svg';
import faves from 'assets/images/postCategories/faves.svg';
import fitness from 'assets/images/postCategories/fitness.svg';
import growth from 'assets/images/postCategories/growth.svg';
import hardships from 'assets/images/postCategories/hardships.svg';
import health from 'assets/images/postCategories/health.svg';
import journeys from 'assets/images/postCategories/journeys.svg';
import learning from 'assets/images/postCategories/learning.svg';
import moments from 'assets/images/postCategories/moments.svg';
import other from 'assets/images/postCategories/other.svg';
import places from 'assets/images/postCategories/places.svg';
import purpose from 'assets/images/postCategories/purpose.svg';
import relationships from 'assets/images/postCategories/relationships.svg';
import spirituality from 'assets/images/postCategories/spirituality.svg';
import work from 'assets/images/postCategories/work.svg';

export const Basics = () => <img src={basics} alt="Basics " className={classes.ContentCategoryImage} />;

export const Bigs = () => <img src={bigs} alt="Bigs " className={classes.ContentCategoryImage} />;

export const Birthdays = () => <img src={birthdays} alt="Birthdays " className={classes.ContentCategoryImage} />;

export const Celebrations = () => <img src={celebrations} alt="Celebrations " className={classes.ContentCategoryImage} />;

export const Faves = () => <img src={faves} alt="Faves " className={classes.ContentCategoryImage} />;

export const Fitness = () => <img src={fitness} alt="Fitness " className={classes.ContentCategoryImage} />;

export const Growth = () => <img src={growth} alt="Growth " className={classes.ContentCategoryImage} />;

export const Hardships = () => <img src={hardships} alt="Hardships " className={classes.ContentCategoryImage} />;

export const Health = () => <img src={health} alt="Health " className={classes.ContentCategoryImage} />;

export const Journeys = () => <img src={journeys} alt="Journeys " />;

export const Learning = () => <img src={learning} alt="Learning " />;

export const Moments = () => <img src={moments} alt="Moments " />;

export const Places = () => <img src={places} alt="Places " className={classes.ContentCategoryImage} />;

export const Purpose = () => <img src={purpose} alt="Purpose " className={classes.ContentCategoryImage} />;

export const Relationships = () => <img src={relationships} alt="Relationships " className={classes.ContentCategoryImage} />;

export const Spirituality = () => <img src={spirituality} alt="Spirituality " className={classes.ContentCategoryImage} />;

export const Work = () => <img src={work} alt="Work " className={classes.ContentCategoryImage} />;

export const Other = () => <img src={other} alt="Other " className={classes.ContentCategoryImage} />;
